import React, { createContext, useContext, useState } from 'react';

interface ManagedClient {
  client_id: string;
  client_name: string;
  client_email?: string;
  permissions: {
    can_manage_connectors: boolean;
    can_manage_users: boolean;
    can_manage_billing: boolean;
  };
}

interface ClientContextType {
  currentClient: ManagedClient | null;
  setCurrentClient: (client: ManagedClient | null) => void;
  clients: ManagedClient[];
  setClients: (clients: ManagedClient[]) => void;
}

const ClientContext = createContext<ClientContextType | undefined>(undefined);

export function ClientProvider({ children }: { children: React.ReactNode }) {
  const [currentClient, setCurrentClient] = useState<ManagedClient | null>(null);
  const [clients, setClients] = useState<ManagedClient[]>([]);

  return (
    <ClientContext.Provider
      value={{
        currentClient,
        setCurrentClient,
        clients,
        setClients,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
}

export function useClient() {
  const context = useContext(ClientContext);
  if (context === undefined) {
    throw new Error('useClient must be used within a ClientProvider');
  }
  return context;
}
